module.exports = __webpack_public_path__ + "images/sloagan-InterLAB-regularsize.png";